// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportDto } from './IReportDto';
import {
    IReportDtoFromJSON,
    IReportDtoFromJSONTyped,
    IReportDtoToJSON,
    IReportDtoToJSONTyped,
} from './IReportDto';
import type { ITransactionTagDto } from './ITransactionTagDto';
import {
    ITransactionTagDtoFromJSON,
    ITransactionTagDtoFromJSONTyped,
    ITransactionTagDtoToJSON,
    ITransactionTagDtoToJSONTyped,
} from './ITransactionTagDto';
import type { ITransactionWorkflowPostingDto } from './ITransactionWorkflowPostingDto';
import {
    ITransactionWorkflowPostingDtoFromJSON,
    ITransactionWorkflowPostingDtoFromJSONTyped,
    ITransactionWorkflowPostingDtoToJSON,
    ITransactionWorkflowPostingDtoToJSONTyped,
} from './ITransactionWorkflowPostingDto';

/**
 * 
 * @export
 * @interface ICreateTransactionWorkflowDto
 */
export interface ICreateTransactionWorkflowDto {
    /**
     * 
     * @type {string}
     * @memberof ICreateTransactionWorkflowDto
     */
    memo: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateTransactionWorkflowDto
     */
    metadata?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICreateTransactionWorkflowDto
     */
    force?: boolean;
    /**
     * 
     * @type {Set<ITransactionWorkflowPostingDto>}
     * @memberof ICreateTransactionWorkflowDto
     */
    postings: Set<ITransactionWorkflowPostingDto>;
    /**
     * 
     * @type {IReportDto}
     * @memberof ICreateTransactionWorkflowDto
     */
    reports?: IReportDto;
    /**
     * 
     * @type {Set<ITransactionTagDto>}
     * @memberof ICreateTransactionWorkflowDto
     */
    tags?: Set<ITransactionTagDto>;
    /**
     * 
     * @type {string}
     * @memberof ICreateTransactionWorkflowDto
     */
    transaction_request_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICreateTransactionWorkflowDto
     */
    skip_update_balance_on_fiserv?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICreateTransactionWorkflowDto
     */
    transaction_type: ICreateTransactionWorkflowDtoTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ICreateTransactionWorkflowDto
     */
    posting_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateTransactionWorkflowDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICreateTransactionWorkflowDto
     */
    ignore_account_status_validation?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ICreateTransactionWorkflowDto
     */
    detail_invoice_posting_claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateTransactionWorkflowDto
     */
    settled_authorization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateTransactionWorkflowDto
     */
    message_group_id?: string;
}

/**
* @export
* @enum {string}
*/
export enum ICreateTransactionWorkflowDtoTransactionTypeEnum {
    NOTIONAL_FUND = 'NOTIONAL_FUND',
    REPLENISHMENT_PAYMENT = 'REPLENISHMENT_PAYMENT',
    REPLENISHMENT = 'REPLENISHMENT',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    CARD_SETTLEMENT = 'CARD_SETTLEMENT',
    PAY_CLAIM = 'PAY_CLAIM',
    CHECK_CLEARED = 'CHECK_CLEARED',
    CARD_PROCESSOR_PAYMENT = 'CARD_PROCESSOR_PAYMENT',
    RECORD_KEEPING_PAYROLL = 'RECORD_KEEPING_PAYROLL',
    CONTRIBUTION_PAYMENT = 'CONTRIBUTION_PAYMENT',
    PAYROLL = 'PAYROLL',
    EMPLOYER_PAYMENT = 'EMPLOYER_PAYMENT',
    PAYMENT = 'PAYMENT',
    INTEREST = 'INTEREST',
    FEE = 'FEE',
    TRANSFER_OF_ASSETS = 'TRANSFER_OF_ASSETS',
    INVESTMENT = 'INVESTMENT',
    ACH_CLEARED = 'ACH_CLEARED',
    DEBIT_CLEARED = 'DEBIT_CLEARED',
    VENMO_CLEARED = 'VENMO_CLEARED',
    PAYPAL_CLEARED = 'PAYPAL_CLEARED',
    ADJUSTMENT = 'ADJUSTMENT',
    INTEREST_PAYMENT = 'INTEREST_PAYMENT',
    BUY_INVESTMENT = 'BUY_INVESTMENT',
    SELL_INVESTMENT = 'SELL_INVESTMENT',
    BUY_INVESTMENT_CLEARED = 'BUY_INVESTMENT_CLEARED',
    SELL_INVESTMENT_CLEARED = 'SELL_INVESTMENT_CLEARED',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    LOCKBOX_PAYMENT = 'LOCKBOX_PAYMENT',
    PAYMENT_CARD_RETURN = 'PAYMENT_CARD_RETURN',
    ROLLOVER = 'ROLLOVER',
    DIGITAL_SETTLEMENT = 'DIGITAL_SETTLEMENT',
    DEBIT_VENMO_PAYPAL_REJECTED = 'DEBIT_VENMO_PAYPAL_REJECTED',
    RETURN_REPLENISHMENT_PAYMENT = 'RETURN_REPLENISHMENT_PAYMENT',
    RECORD_KEEPING = 'RECORD_KEEPING',
    CONTRIBUTION_PAID = 'CONTRIBUTION_PAID',
    PREFUND_REPLENISHMENT = 'PREFUND_REPLENISHMENT',
    INTERNAL_TRANSFER_OF_ASSETS = 'INTERNAL_TRANSFER_OF_ASSETS',
    HSA_INCOMING_CONTRIBUTION = 'HSA_INCOMING_CONTRIBUTION',
    HSA_ROLLOVER = 'HSA_ROLLOVER',
    ORPHAN_EE_FEE = 'ORPHAN_EE_FEE',
    ORPHAN_EE_FEE_PAYMENT = 'ORPHAN_EE_FEE_PAYMENT',
    ADMIN_FEE = 'ADMIN_FEE',
    ADMIN_FEE_PAYMENT = 'ADMIN_FEE_PAYMENT',
    REPLENISHMENT_REVERSE = 'REPLENISHMENT_REVERSE',
    ACH_REJECTED = 'ACH_REJECTED',
    RETURN_CONTRIBUTION_PAYMENT = 'RETURN_CONTRIBUTION_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_REVERSE = 'HSA_INCOMING_CONTRIBUTION_REVERSE',
    HSA_ROLLOVER_REVERSE = 'HSA_ROLLOVER_REVERSE',
    INVESTMENT_FEES = 'INVESTMENT_FEES',
    REPLENISHMENT_FUNDING_REVERSE = 'REPLENISHMENT_FUNDING_REVERSE',
    RETURN_REPLENISHMENT_FUNDING_PAYMENT = 'RETURN_REPLENISHMENT_FUNDING_PAYMENT',
    CLAIM_TRANSFER = 'CLAIM_TRANSFER',
    CLAIM_TRANSFER_INTERNAL = 'CLAIM_TRANSFER_INTERNAL',
    PAYROLL_REVERSE = 'PAYROLL_REVERSE',
    CONTRIBUTION_PAID_REVERSE = 'CONTRIBUTION_PAID_REVERSE',
    CONTRIBUTION_REVERSE_PAYMENT = 'CONTRIBUTION_REVERSE_PAYMENT',
    PREFUND_REPLENISHMENT_RETURN = 'PREFUND_REPLENISHMENT_RETURN',
    FINAL_PREFUND_REPLENISHMENT_RETURN = 'FINAL_PREFUND_REPLENISHMENT_RETURN',
    PREFUND_PAYMENT = 'PREFUND_PAYMENT',
    PREFUND_INTER = 'PREFUND_INTER',
    RETURN_PREFUND_FUNDING_PAYMENT = 'RETURN_PREFUND_FUNDING_PAYMENT',
    PREFUND_FINAL = 'PREFUND_FINAL',
    PREFUND_FUNDING_REVERSE = 'PREFUND_FUNDING_REVERSE',
    RETURN_LOCKBOX = 'RETURN_LOCKBOX',
    INBOUND_CHECK_CLEARED = 'INBOUND_CHECK_CLEARED',
    LOCKBOX_INCOMING = 'LOCKBOX_INCOMING',
    INBOUND_TRANSFER_OF_ASSETS = 'INBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_TRANSFER_OF_ASSETS = 'OUTBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_CHECK_CLEARED = 'OUTBOUND_CHECK_CLEARED',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    WRITE_OFF = 'WRITE_OFF',
    FORFEITURE = 'FORFEITURE',
    PUSH_REPLENISHMENT_PAYMENT = 'PUSH_REPLENISHMENT_PAYMENT',
    PUSH_PREFUND_PAYMENT = 'PUSH_PREFUND_PAYMENT',
    PUSH_CONTRIBUTION_PAYMENT = 'PUSH_CONTRIBUTION_PAYMENT',
    PAYMENT_EE_FEE = 'PAYMENT_EE_FEE',
    ACCOUNT_MAINTENANCE_EE_FEE = 'ACCOUNT_MAINTENANCE_EE_FEE',
    PAPER_STATEMENT_EE_FEE = 'PAPER_STATEMENT_EE_FEE',
    EE_FEES_BULK_PAYMENT = 'EE_FEES_BULK_PAYMENT',
    OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS = 'OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS',
    FEE_TRANSFER_INTERNAL = 'FEE_TRANSFER_INTERNAL',
    FEE_TRANSFER = 'FEE_TRANSFER',
    CLAIM_REJECTION = 'CLAIM_REJECTION',
    ACH_CLAIM_REPAYMENT = 'ACH_CLAIM_REPAYMENT',
    ACH_CLAIM_REPAYMENT_REJECTED = 'ACH_CLAIM_REPAYMENT_REJECTED',
    CLAIM_REPAYMENT_REJECTION = 'CLAIM_REPAYMENT_REJECTION',
    CLAIM_REPAYMENT_TRANSFER_INTERNAL = 'CLAIM_REPAYMENT_TRANSFER_INTERNAL',
    CLAIM_REPAYMENT_TRANSFER = 'CLAIM_REPAYMENT_TRANSFER',
    LOCKBOX_CHECK_CLEARED = 'LOCKBOX_CHECK_CLEARED',
    LOCKBOX_CLAIM_REPAYMENT = 'LOCKBOX_CLAIM_REPAYMENT',
    NOTIONAL_CONTRIBUTION_PAID = 'NOTIONAL_CONTRIBUTION_PAID',
    PREFUND_RETURN_PAYMENT_REVERSE = 'PREFUND_RETURN_PAYMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT = 'CLAIM_BALANCE_ADJUSTMENT',
    NOTIONAL_CONTRIBUTION_PAID_REVERSE = 'NOTIONAL_CONTRIBUTION_PAID_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT = 'ROLLOVER_BALANCE_ADJUSTMENT',
    EOY_PLAN_FUNDS_INTERNAL_RETURN = 'EOY_PLAN_FUNDS_INTERNAL_RETURN',
    PUSH_RETURN_PAYMENT = 'PUSH_RETURN_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_PAYMENT = 'HSA_INCOMING_CONTRIBUTION_PAYMENT',
    NOTIONAL_PAYROLL_REVERSE = 'NOTIONAL_PAYROLL_REVERSE',
    EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION = 'EOY_PLAN_SHORTAGE_COLLECTION',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT',
    PUSH_UNKNOWN_PAYMENT = 'PUSH_UNKNOWN_PAYMENT',
    UNMATCHED_PUSH_KEEPING = 'UNMATCHED_PUSH_KEEPING',
    PUSH_INVOICE_PAYMENT = 'PUSH_INVOICE_PAYMENT',
    UNMATCHED_PUSH_RETURN = 'UNMATCHED_PUSH_RETURN',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL',
    ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS = 'ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL',
    BULK_BALANCE_ADJUSTMENT = 'BULK_BALANCE_ADJUSTMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE',
    BULK_BALANCE_ADJUSTMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE'
}


/**
 * Check if a given object implements the ICreateTransactionWorkflowDto interface.
 */
export function instanceOfICreateTransactionWorkflowDto(value: object): value is ICreateTransactionWorkflowDto {
    if (!('memo' in value) || value['memo'] === undefined) return false;
    if (!('postings' in value) || value['postings'] === undefined) return false;
    if (!('transaction_type' in value) || value['transaction_type'] === undefined) return false;
    return true;
}

export function ICreateTransactionWorkflowDtoFromJSON(json: any): ICreateTransactionWorkflowDto {
    return ICreateTransactionWorkflowDtoFromJSONTyped(json, false);
}

export function ICreateTransactionWorkflowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateTransactionWorkflowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'memo': json['memo'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'force': json['force'] == null ? undefined : json['force'],
        'postings': (new Set((json['postings'] as Array<any>).map(ITransactionWorkflowPostingDtoFromJSON))),
        'reports': json['reports'] == null ? undefined : IReportDtoFromJSON(json['reports']),
        'tags': json['tags'] == null ? undefined : (new Set((json['tags'] as Array<any>).map(ITransactionTagDtoFromJSON))),
        'transaction_request_id': json['transaction_request_id'] == null ? undefined : json['transaction_request_id'],
        'skip_update_balance_on_fiserv': json['skip_update_balance_on_fiserv'] == null ? undefined : json['skip_update_balance_on_fiserv'],
        'transaction_type': json['transaction_type'],
        'posting_account_id': json['posting_account_id'] == null ? undefined : json['posting_account_id'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'ignore_account_status_validation': json['ignore_account_status_validation'] == null ? undefined : json['ignore_account_status_validation'],
        'detail_invoice_posting_claim_id': json['detail_invoice_posting_claim_id'] == null ? undefined : json['detail_invoice_posting_claim_id'],
        'settled_authorization_id': json['settled_authorization_id'] == null ? undefined : json['settled_authorization_id'],
        'message_group_id': json['message_group_id'] == null ? undefined : json['message_group_id'],
    };
}

export function ICreateTransactionWorkflowDtoToJSON(json: any): ICreateTransactionWorkflowDto {
    return ICreateTransactionWorkflowDtoToJSONTyped(json, false);
}

export function ICreateTransactionWorkflowDtoToJSONTyped(value?: ICreateTransactionWorkflowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'memo': value['memo'],
        'metadata': value['metadata'],
        'force': value['force'],
        'postings': (Array.from(value['postings'] as Set<any>).map(ITransactionWorkflowPostingDtoToJSON)),
        'reports': IReportDtoToJSON(value['reports']),
        'tags': value['tags'] == null ? undefined : (Array.from(value['tags'] as Set<any>).map(ITransactionTagDtoToJSON)),
        'transaction_request_id': value['transaction_request_id'],
        'skip_update_balance_on_fiserv': value['skip_update_balance_on_fiserv'],
        'transaction_type': value['transaction_type'],
        'posting_account_id': value['posting_account_id'],
        'external_identifier': value['external_identifier'],
        'ignore_account_status_validation': value['ignore_account_status_validation'],
        'detail_invoice_posting_claim_id': value['detail_invoice_posting_claim_id'],
        'settled_authorization_id': value['settled_authorization_id'],
        'message_group_id': value['message_group_id'],
    };
}

